import { Col, Row, Table, Typography, Space, Button, Popconfirm, message } from "antd"
import { useMemo, useState } from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { PiUserList } from "react-icons/pi"
import { useCollection } from "../../../hooks/useCollection"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { TableSearch } from "../../../components/utils/TableSearch"
import moment from "moment"
import { db } from "../../../firebase/config"
import { deleteDoc, doc } from "firebase/firestore"
import CreateClientPopup from "../../../components/Clients/CreateClientPopup"
import ClientDetailDrawer from "../../../components/Clients/ClientDetailDrawer"

const { Text, Link } = Typography

export default function Leads() {
  const { user, admin, semiAdmin, devSpecialist } = useAuthContext()
  const [selectedLead, setSelectedLead] = useState(null)
  const [drawerOpen, setDrawerOpen] = useState(false)

  const queryFilter = useMemo(() => {
    if (admin || semiAdmin || devSpecialist) return null
    return ["user", "==", user.uid]
  }, [user, admin, semiAdmin, devSpecialist])

  const { loading, data } = useCollection("leads", queryFilter || undefined)

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "leads", id))
      message.success("Lead deleted successfully.")
      setDrawerOpen(false)
    } catch (err) {
      console.error("Error deleting lead:", err)
      message.error("Failed to delete lead.")
    }
  }

  const openDrawer = (record) => {
    setSelectedLead(record)
    setDrawerOpen(true)
  }

  const columns = [
    {
      title: "Company Name",
      dataIndex: "client",
      ...TableSearch("client"),
      render: (value, record) => (
        <Link onClick={() => openDrawer(record)}>{value}</Link>
      ),
    },
    {
      title: "VAT",
      dataIndex: "vat",
      align: "center",
      sorter: {
        compare: (a, b) => (a.vat || "").localeCompare(b.vat || ""),
      },
    },
    {
      title: "Country",
      dataIndex: "country",
      align: "center",
      sorter: {
        compare: (a, b) => (a.country || "").localeCompare(b.country || ""),
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      sorter: (a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0),
      render: (value) =>
        value?.seconds ? (
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY HH:mm")}</Text>
        ) : (
          <Text italic>N/A</Text>
        ),
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Space>
          <CreateClientPopup prefill={record} icon={false} />
          <Popconfirm
            title="Delete this lead?"
            onConfirm={async () => await handleDelete(record.id)}>
            <Button danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ]

  return (
    <div className="page-padding">
      <Row>
        <Col span={24}>
          <PageHeader text="Leads List" icon={<PiUserList />} />
        </Col>
        <Col span={24}>
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            size="small"
            loading={loading}
            dataSource={data}
            pagination={{ defaultPageSize: 50, showSizeChanger: true }}
          />
        </Col>
      </Row>

      <ClientDetailDrawer
        record={selectedLead}
        type="lead"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onDelete={handleDelete}
      />
    </div>
  )
}
